import requiredLabel from '../../images/required.png';

function LabelRequired({ text, required = true }: { text: string; required?: boolean }) {
  return (
    <div className='flex gap-2 items-center mb-2'>
      <p className='mb-0 text-lg font-semibold'>{text}</p>
      {required && <img src={requiredLabel} alt='Required' />}
    </div>
  );
}

export default LabelRequired;
